/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:54:14.

export interface AuthorizeServiceLoginRequest {
  userIdentityId: string;
  terminalSerialNumber: string;
  cpuNumber: string;
}

export interface AuthorizeUserLoginRequest {
  userIdentityId: string;
  agentSubservicePermission: number;
  agentId: string;
  locationId: string;
  terminalId: string;
  merchantId: string;
}

export interface AuthorizeUserLoginRequestWithOtp extends AuthorizeUserLoginRequest {
  otpId: string;
  otpCode: string;
}

export interface WebBooleanResponse {
  result: boolean;
  problemResponseData?: ProblemResponseData | null;
}

export interface CopyApplicationRoleRequest {
  platformApplicationRoleId: string;
}

export interface CopyCategoryRoleRequest {
  platformCategoryRoleId: string;
}

export interface ApplicationRoleCategoryRequest {}

export interface CategoryRolePermissionRequest {}

export interface ApplicationRoleRequest {}

export interface CategoryRoleRequest {}

export interface ConfirmOTPRequest {
  otpRequestId: string;
  otpCode: string;
}

export interface CreateRegistrationOTPRequest {
  mobile: string;
  email: string;
}

export interface WebUUIDResponse {
  result: string;
  problemResponseData?: ProblemResponseData | null;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  mobile: string;
}

export interface CreateUserRequestThemself {
  username: string;
  password: string;
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  otpRegistrationId: string;
}

export interface CreateUserFromPersonRequest {
  username: string;
  email: string;
  applicationId: string;
  personEntryId: string;
}

export interface DeleteUserApplicationRoleRequest {
  userRoleId: string;
}

export interface EnableUserRequest {
  userId: string;
  enable: boolean;
}

export interface EnableUserGrantRequest {
  grantingId: string;
  enable: boolean;
}

export interface FindUsersRequest {
  applicationId: string;
  applicationGroupId: string;
  firstName: string;
  lastName: string;
  applicationRoleId: string;
  categoryRoleId: string;
  personalID: string;
  email: string;
}

export interface SetAgentUserApplicationRoleRequest {
  grantingId: string;
  applicationRoleId: string;
  agentId: string;
  locationId: string;
  terminalId: string;
}

export interface SetMasterAgentUserApplicationRoleRequest {
  grantingId: string;
  applicationRoleId: string;
  childMasterAgentId: string;
}

export interface SetMerchantUserApplicationRoleRequest {
  grantingId: string;
  applicationRoleId: string;
  merchantId: string;
}

export interface SetProviderUserApplicationRoleRequest {
  grantingId: string;
  applicationRoleId: string;
}

export interface GrantUserApplicationRequest {
  userId: string;
  applicationId: string;
  enable: boolean;
}

export interface WebResponseEntity<T> {
  result: T;
  problemResponseData?: ProblemResponseData | null;
}

export interface LoginOTPResponseDto {
  otpRequestId: string;
  type: LoginOTPResponseType;
}

export interface AuthorizeServiceResponseDto {
  authorizeResposne: boolean;
  jwk: string;
  servicePermissions: { [index: string]: string };
  jsonPermissions: { [index: string]: boolean };
}

export interface AuthorizeUserResponseDto {
  authorizeResposne: ResponseCode;
  userId: string;
  jwk: string;
  subserviceToken: number;
  appServiceToken: { [index: string]: number };
  jsonSubservicePermissions: { [index: string]: string };
  jsonApplicationPermissions: { [index: string]: boolean };
}

export interface WebResponseObject<T> extends WebResponseBase {
  result: T;
}

export interface ApplicationRoleResponseDto {
  id: string;
  name: string;
  description: string;
  applicationId: string;
  defaultRole: boolean;
  enabled: boolean;
}

export interface CategoryRoleResponseDto {
  id: string;
  name: string;
  description: string;
  applicationType: PlatformApplicationTypeEnum;
  groupName: string;
  enabled: boolean;
}

export interface WebListResponseEntity<T> {
  result: T[];
  problemResponseData?: ProblemResponseData | null;
}

export interface PermissionGroupResponseDto {
  name: string;
  permissions: PermissionResponseDto[];
}

export interface CategoryGroupResponseDto {
  name: string;
  roles: CategoryRoleResponseDto[];
}

export interface PermissionResponseDto {
  id: number;
  name: string;
  description: string;
  groupName: string;
}

export interface ConfirmOTPResponseDto {}

export interface CreateUserResponseDto extends RequestHeaderInfoDtoBase {
  result: boolean;
  userId: string;
  wasAbsent: boolean;
}

export interface AgentUserApplicationRoleDto {
  userRoleId: string;
  applicationRoleId: string;
  agentId: string;
  locationId: string;
  terminalId: string;
}

export interface MasterAgentUserApplicationRoleDto {
  userRoleId: string;
  applicationRoleId: string;
  childMasterAgentId: string;
}

export interface MerchantUserApplicationRoleDto {
  userRoleId: string;
  applicationRoleId: string;
  merchantId: string;
}

export interface ProviderUserApplicationRoleDto {
  userRoleId: string;
  applicationRoleId: string;
}

export interface UserGrantingResposneDto {
  grantingId: string;
  enabled: boolean;
}

export interface ProblemResponseData extends Serializable {
  error: boolean;
  problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
  problemResponseData: ProblemResponseData;
}

export interface RequestHeaderBaseInfo {
  userType: RequestUserType;
  appInfo: RequestApplicationInfo;
  masterAgentInfo: RequestMasterAgentInfo;
  userInfo: RequestUserInfo;
  agentInfo: RequestAgentInfo;
  merchantInfo: RequestMerchantInfo;
}

export interface RequestHeaderInfoDtoBase {
  requestHeaderInfo: RequestHeaderBaseInfo;
}

export interface ResponseEntity<T> {
  result: T;
  problemResponseData?: ProblemResponseData | null;
}

export interface ProblemBase extends Serializable {
  problemCode: number;
  applicationOrigin: string;
  exceptionCode: string;
  message: string;
  details: string;
  type: string;
}

export interface Serializable {}

export interface RequestApplicationInfo extends RequestInfo {
  serviceRequest: boolean;
  applicationId: string;
  language: string;
}

export interface RequestMasterAgentInfo extends RequestInfo {
  masterAgentAccessId: string;
  country: string;
}

export interface RequestUserInfo extends RequestInfo {
  userId: string;
  requestPermission: number;
  subservicePermission: number;
}

export interface RequestAgentInfo extends RequestInfo {
  terminalId: string;
  locationId: string;
  agentId: string;
}

export interface RequestMerchantInfo extends RequestInfo {
  merchantId: string;
}

export interface RequestInfo {}

export interface HttpEntity<T> {
  headers: { [index: string]: string[] };
  body: T;
}

export interface HttpClient<O> {
  request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
    options?: O;
  }): RestResponse<R>;
}

export class RestApplicationClient<O> {
  constructor(protected httpClient: HttpClient<O>) {}

  /**
   * HTTP POST /user/auth/create-login-otp
   * Java method: com.europoint.usermanagement.web.controllers.AuthorizationController.createLoginOTP
   */
  createLoginOTP(options?: O): RestResponse<WebResponseEntity<LoginOTPResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/auth/create-login-otp`,
      options: options,
    });
  }

  /**
   * HTTP POST /user/auth/service-authorization
   * Java method: com.europoint.usermanagement.web.controllers.AuthorizationController.doServiceAuthorization
   */
  doServiceAuthorization(
    agentUserLogInRequest: AuthorizeServiceLoginRequest,
    options?: O
  ): RestResponse<WebResponseEntity<AuthorizeServiceResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/auth/service-authorization`,
      data: agentUserLogInRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/auth/user-authorization
   * Java method: com.europoint.usermanagement.web.controllers.AuthorizationController.doUserAuthorization
   */
  doUserAuthorization(
    userLogInRequest: AuthorizeUserLoginRequest,
    options?: O
  ): RestResponse<WebResponseEntity<AuthorizeUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/auth/user-authorization`,
      data: userLogInRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/auth/user-authorization-otp
   * Java method: com.europoint.usermanagement.web.controllers.AuthorizationController.doUserAuthorizationWithOtp
   */
  doUserAuthorizationWithOtp(
    userLogInRequest: AuthorizeUserLoginRequestWithOtp,
    options?: O
  ): RestResponse<WebResponseEntity<AuthorizeUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/auth/user-authorization-otp`,
      data: userLogInRequest,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-application-category-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllApplicationCategoryRoles
   */
  getAllApplicationCategoryRoles(
    queryParams: { applictionRoleId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-application-category-roles`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-application-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllApplicationRoles
   */
  getAllApplicationRoles$GET$user_role_allapplicationroles(
    queryParams: { enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-application-roles`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-application-roles-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllApplicationRoles
   */
  getAllApplicationRoles$GET$user_role_allapplicationrolesbyapp(
    queryParams: { applictionId: string; enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-application-roles-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-groups
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryGroups
   */
  getAllCategoryGroups(
    queryParams: { enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<string>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-groups`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-permissions
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryPermissions
   */
  getAllCategoryPermissions(
    queryParams: { categoryRoleId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-permissions`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRoles
   */
  getAllCategoryRoles$GET$user_role_allcategoryroles(
    queryParams: { enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRoles
   */
  getAllCategoryRoles$GET$user_role_allcategoryrolesbyapp(
    queryParams: { applictionId: string; enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles-by-app-type
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRoles
   */
  getAllCategoryRoles$GET$user_role_allcategoryrolesbyapptype(
    queryParams: { applicationType: PlatformApplicationTypeEnum; enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles-by-app-type`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles-from-group
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRolesFromGroup
   */
  getAllCategoryRolesFromGroup$GET$user_role_allcategoryrolesfromgroup(
    queryParams: { groupName: string; enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles-from-group`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles-from-group-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRolesFromGroup
   */
  getAllCategoryRolesFromGroup$GET$user_role_allcategoryrolesfromgroupbyapp(
    queryParams: { groupName: string; applictionId: string; enabledOnly: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles-from-group-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-category-roles-from-group-by-app-type
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllCategoryRolesFromGroup
   */
  getAllCategoryRolesFromGroup$GET$user_role_allcategoryrolesfromgroupbyapptype(
    queryParams: {
      groupName: string;
      applicationType: PlatformApplicationTypeEnum;
      enabledOnly: boolean;
    },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-category-roles-from-group-by-app-type`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permission-groups
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissionGroups
   */
  getAllPermissionGroups(options?: O): RestResponse<WebListResponseEntity<string>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permission-groups`,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissions(
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions`,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissionsbyapp(
    queryParams: { applictionId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions-by-apptype
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissionsbyapptype(
    queryParams: { applicationType: PlatformApplicationTypeEnum },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions-by-apptype`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions-from-group
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissionsfromgroup(
    queryParams: { groupName: string },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions-from-group`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions-from-group-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissionsfromgroupbyapp(
    queryParams: { groupName: string; applictionId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions-from-group-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-permissions-from-group-by-apptype
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPermissions
   */
  getAllPermissions$GET$user_role_allpermissionsfromgroupbyapptype(
    queryParams: { groupName: string; applicationType: PlatformApplicationTypeEnum },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-permissions-from-group-by-apptype`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-application-category-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformApplicationCategoryRoles
   */
  getAllPlatformApplicationCategoryRoles(
    queryParams: { applictionRoleId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-application-category-roles`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-application-roles-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformApplicationRoles
   */
  getAllPlatformApplicationRoles(
    queryParams: { applictionId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-application-roles-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-groups
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryGroups
   */
  getAllPlatformCategoryGroups(options?: O): RestResponse<WebListResponseEntity<string>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-groups`,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-permissions
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryPermissions
   */
  getAllPlatformCategoryPermissions(
    queryParams: { categoryRoleId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<PermissionGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-permissions`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-roles-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryRoles
   */
  getAllPlatformCategoryRoles$GET$user_role_allplatformcategoryrolesbyapp(
    queryParams: { applictionId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-roles-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-roles-by-app-type
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryRoles
   */
  getAllPlatformCategoryRoles$GET$user_role_allplatformcategoryrolesbyapptype(
    queryParams: { applicationType: PlatformApplicationTypeEnum },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryGroupResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-roles-by-app-type`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-roles-from-group-by-app
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryRolesFromGroup
   */
  getAllPlatformCategoryRolesFromGroup$GET$user_role_allplatformcategoryrolesfromgroupbyapp(
    queryParams: { groupName: string; applictionId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-roles-from-group-by-app`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/role/all-platform-category-roles-from-group-by-app-type
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.getAllPlatformCategoryRolesFromGroup
   */
  getAllPlatformCategoryRolesFromGroup$GET$user_role_allplatformcategoryrolesfromgroupbyapptype(
    queryParams: { groupName: string; applicationType: PlatformApplicationTypeEnum },
    options?: O
  ): RestResponse<WebListResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/role/all-platform-category-roles-from-group-by-app-type`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/copy-all-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.copyAllRoles
   */
  copyAllRoles(options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/copy-all-roles`,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/copy-application-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.copyPlatformApplicationRole
   */
  copyPlatformApplicationRole(
    request: CopyApplicationRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/copy-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/copy-category-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.copyPlatformCategoryRole
   */
  copyPlatformCategoryRole(
    request: CopyCategoryRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/copy-category-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/create-application-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.createPlatformApplicationRole
   */
  createPlatformApplicationRole(
    request: ApplicationRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/create-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/create-category-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.createPlatformCategoryRole
   */
  createPlatformCategoryRole(
    request: CategoryRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/create-category-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/update-application-category-roles
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.createApplicationRoleCategory
   */
  createApplicationRoleCategory(
    createRequest: ApplicationRoleCategoryRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/update-application-category-roles`,
      data: createRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/update-application-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.updatePlatformApplicationRole
   */
  updatePlatformApplicationRole(
    request: ApplicationRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<ApplicationRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/update-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/update-category-permissions
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.createCategoryRolePermission
   */
  createCategoryRolePermission(
    request: CategoryRolePermissionRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/update-category-permissions`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/role/update-category-role
   * Java method: com.europoint.usermanagement.web.controllers.RoleController.updatePlatformCategoryRole
   */
  updatePlatformCategoryRole(
    request: CategoryRoleRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CategoryRoleResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/role/update-category-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/agent-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getAgentUserApplicationRoles
   */
  getAgentUserApplicationRoles(
    queryParams: { grantingId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<AgentUserApplicationRoleDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/agent-user-application-role`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/confirm-registration-otp
   * Java method: com.europoint.usermanagement.web.controllers.UserController.confirmOTP
   */
  confirmOTP(
    confirmRequest: ConfirmOTPRequest,
    options?: O
  ): RestResponse<WebResponseEntity<ConfirmOTPResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/confirm-registration-otp`,
      data: confirmRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/create-registration-otp
   * Java method: com.europoint.usermanagement.web.controllers.UserController.createRegistrationOTP
   */
  createRegistrationOTP(
    createRequest: CreateRegistrationOTPRequest,
    options?: O
  ): RestResponse<WebUUIDResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/create-registration-otp`,
      data: createRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/create-user
   * Java method: com.europoint.usermanagement.web.controllers.UserController.createUser
   */
  createUser$POST$user_user_createuser(
    createUserRequest: CreateUserRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CreateUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/create-user`,
      data: createUserRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/create-user-from-person
   * Java method: com.europoint.usermanagement.web.controllers.UserController.createUserFromPerson
   */
  createUserFromPerson(
    createUserRequest: CreateUserFromPersonRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CreateUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/create-user-from-person`,
      data: createUserRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/create-user-themself
   * Java method: com.europoint.usermanagement.web.controllers.UserController.createUser
   */
  createUser$POST$user_user_createuserthemself(
    createUserRequest: CreateUserRequestThemself,
    options?: O
  ): RestResponse<WebResponseEntity<CreateUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/create-user-themself`,
      data: createUserRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/delete-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.deleteUserApplicationRole
   */
  deleteUserApplicationRole(
    request: DeleteUserApplicationRoleRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/delete-user-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/enable-user
   * Java method: com.europoint.usermanagement.web.controllers.UserController.enableUser
   */
  enableUser(request: EnableUserRequest, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/enable-user`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/enable-user-grant
   * Java method: com.europoint.usermanagement.web.controllers.UserController.enableUserGrant
   */
  enableUserGrant(request: EnableUserGrantRequest, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/enable-user-grant`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/find-user
   * Java method: com.europoint.usermanagement.web.controllers.UserController.findUser
   */
  findUser(
    request: FindUsersRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CreateUserResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/find-user`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/get-user-granting
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getUserGranting
   */
  getUserGranting(
    queryParams: { userId: string; applicationId: string },
    options?: O
  ): RestResponse<WebResponseEntity<UserGrantingResposneDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/get-user-granting`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/master-agent-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getMasterAgentUserApplicationRoles
   */
  getMasterAgentUserApplicationRoles(
    queryParams: { grantingId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<MasterAgentUserApplicationRoleDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/master-agent-user-application-role`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/merchant-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getMerchantUserApplicationRole
   */
  getMerchantUserApplicationRole(
    queryParams: { grantingId: string },
    options?: O
  ): RestResponse<WebResponseEntity<MerchantUserApplicationRoleDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/merchant-user-application-role`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/provider-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getProviderUserApplicationRole
   */
  getProviderUserApplicationRole(
    queryParams: { grantingId: string },
    options?: O
  ): RestResponse<WebResponseEntity<ProviderUserApplicationRoleDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/provider-user-application-role`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/set-agent-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.setAgentUserApplicationRole
   */
  setAgentUserApplicationRole(
    request: SetAgentUserApplicationRoleRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/set-agent-user-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/set-master-agent-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.setMasterAgentUserApplicationRole
   */
  setMasterAgentUserApplicationRole(
    request: SetMasterAgentUserApplicationRoleRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/set-master-agent-user-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/set-merchant-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.setMerchantUserApplicationRole
   */
  setMerchantUserApplicationRole(
    request: SetMerchantUserApplicationRoleRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/set-merchant-user-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/set-provider-user-application-role
   * Java method: com.europoint.usermanagement.web.controllers.UserController.setProviderUserApplicationRole
   */
  setProviderUserApplicationRole(
    request: SetProviderUserApplicationRoleRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/set-provider-user-application-role`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /user/user/set-user-application-grant
   * Java method: com.europoint.usermanagement.web.controllers.UserController.setUserApplicationGrant
   */
  setUserApplicationGrant(
    request: GrantUserApplicationRequest,
    options?: O
  ): RestResponse<WebResponseEntity<UserGrantingResposneDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`user/user/set-user-application-grant`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /user/user/user-by-id
   * Java method: com.europoint.usermanagement.web.controllers.UserController.getUserById
   */
  getUserById(
    queryParams: { userId: string; applicationId: string },
    options?: O
  ): RestResponse<WebResponseEntity<CreateUserResponseDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`user/user/user-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export const enum PlatformApplicationTypeEnum {
  Undefined = 'Undefined',
  PlatformProviderConsole = 'PlatformProviderConsole',
  MasterAgentConsole = 'MasterAgentConsole',
  MasterAgentService = 'MasterAgentService',
  WebMasterAgent = 'WebMasterAgent',
  AgentConsole = 'AgentConsole',
  AgentService = 'AgentService',
  WebAgent = 'WebAgent',
  MerchantConsole = 'MerchantConsole',
  MerchantService = 'MerchantService',
  WebMerchant = 'WebMerchant',
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
  CONTINUE = 'CONTINUE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  PROCESSING = 'PROCESSING',
  CHECKPOINT = 'CHECKPOINT',
  OK = 'OK',
  CREATED = 'CREATED',
  ACCEPTED = 'ACCEPTED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NO_CONTENT = 'NO_CONTENT',
  RESET_CONTENT = 'RESET_CONTENT',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  MULTI_STATUS = 'MULTI_STATUS',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  IM_USED = 'IM_USED',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  FOUND = 'FOUND',
  /**
   * @deprecated
   */
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  SEE_OTHER = 'SEE_OTHER',
  NOT_MODIFIED = 'NOT_MODIFIED',
  /**
   * @deprecated
   */
  USE_PROXY = 'USE_PROXY',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  CONFLICT = 'CONFLICT',
  GONE = 'GONE',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  /**
   * @deprecated
   */
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  URI_TOO_LONG = 'URI_TOO_LONG',
  /**
   * @deprecated
   */
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  /**
   * @deprecated
   */
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  /**
   * @deprecated
   */
  METHOD_FAILURE = 'METHOD_FAILURE',
  /**
   * @deprecated
   */
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  LOCKED = 'LOCKED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  TOO_EARLY = 'TOO_EARLY',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  LOOP_DETECTED = 'LOOP_DETECTED',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
}

export const enum LoginOTPResponseType {
  Email = 'Email',
  Mobile = 'Mobile',
}

export const enum ResponseCode {
  OK = 'OK',
  LoginOtpExpired = 'LoginOtpExpired',
  LoginOtpFailed = 'LoginOtpFailed',
  ApplicationPermissonRequired = 'ApplicationPermissonRequired',
  PersonRegistrationRequired = 'PersonRegistrationRequired',
  Error = 'Error',
}

export const enum RequestUserType {
  Undefined = 'Undefined',
  ProviderUser = 'ProviderUser',
  MasterAgentUser = 'MasterAgentUser',
  MasterAgentService = 'MasterAgentService',
  WebMasterAgentUser = 'WebMasterAgentUser',
  AgentUser = 'AgentUser',
  AgentService = 'AgentService',
  WebAgentUser = 'WebAgentUser',
  MerchantUser = 'MerchantUser',
  MerchantService = 'MerchantService',
  WebMerchantUser = 'WebMerchantUser',
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}

// Added by 'AxiosClientExtension' extension

import axios from 'axios';
import * as Axios from 'axios';

declare module 'axios' {
  export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
    data: R;
  }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {
  constructor(private axios: Axios.AxiosInstance) {}

  request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
    options?: Axios.AxiosRequestConfig;
  }): RestResponse<R> {
    function assign(target: any, source?: any) {
      if (source != undefined) {
        for (const key in source) {
          if (source.hasOwnProperty(key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    }

    const config: Axios.AxiosRequestConfig = {};
    config.method = requestConfig.method as typeof config.method; // `string` in axios 0.16.0, `Method` in axios 0.19.0
    config.url = requestConfig.url;
    config.params = requestConfig.queryParams;
    config.data = requestConfig.data;
    assign(config, requestConfig.options);
    const copyFn = requestConfig.copyFn;

    const axiosResponse = this.axios.request(config);
    return axiosResponse.then((axiosResponse) => {
      if (copyFn && axiosResponse.data) {
        (axiosResponse as any).originalData = axiosResponse.data;
        axiosResponse.data = copyFn(axiosResponse.data);
      }
      return axiosResponse;
    });
  }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {
  constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
    axiosInstance.defaults.baseURL = baseURL;
    super(new AxiosHttpClient(axiosInstance));
  }
}
